import { Component, inject, OnDestroy, computed, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupComponent } from './shared/components/confirm-popup/confirm-popup.component';
import { AuthService } from './core/auth/services/auth.service';
import { Loader } from './shared/components/loader/loader';
import { Layout } from './core/layout';
import { ProductService } from './core/services/product.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Loader, Layout, ToastModule, ConfirmPopupComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnDestroy {
  private authService = inject(AuthService);
  private productService = inject(ProductService);

  // Computed loading state based on auth initialization
  isLoading = computed(() => !this.authService.isInitialized());

  // Computed authentication state
  isAuthenticated = computed(() => this.authService.isUserAuthenticated());

  // Computed logout state
  isLoggingOut = computed(() => this.authService.isUserLoggingOut());

  private productsPrefetched = false;

  constructor() {
    // Prefetch products after authentication to avoid delay in opening routes
    effect(() => {
      if (this.isAuthenticated() && !this.productsPrefetched) {
        this.productsPrefetched = true;
        this.productService.initializeProducts().subscribe();
      }
    });
  }

  ngOnDestroy(): void {
    this.authService.destroy();
  }
}
